import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Zap } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { AuthorSpeedData } from '@/lib/analyticsUtils';

interface AuthorSpeedInsightsProps {
  authorData: AuthorSpeedData[];
}

export function AuthorSpeedInsights({ authorData }: AuthorSpeedInsightsProps) {
  if (authorData.length === 0) return null;

  return (
    <Card className="card-elevated">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="w-5 h-5 text-accent" />
          Reading Speed by Author
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-4">
          Which authors you read fastest (minimum 2 books per author)
        </p>
        
        <div className="space-y-4">
          {authorData.map((author, index) => (
            <div key={author.author} className="space-y-2">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-6 h-6 rounded-full bg-accent/10 flex items-center justify-center text-xs font-bold text-accent">
                      {index + 1}
                    </div>
                    <span className="font-medium">{author.author}</span>
                  </div>
                  <div className="pl-8 space-y-1">
                    <div className="flex items-center gap-2">
                      <Badge variant="secondary" className="text-xs">
                        {author.averageDays} days average
                      </Badge>
                      <span className="text-xs text-muted-foreground">
                        {author.bookCount} book{author.bookCount !== 1 ? 's' : ''}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Zap className="w-3 h-3" />
                      <span>
                        Fastest: <span className="font-medium">{author.fastestBook}</span> in {author.fastestDays} day{author.fastestDays !== 1 ? 's' : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {index < authorData.length - 1 && (
                <div className="border-b border-border/50" />
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
